import React from 'react';
import useGSAP, { gsap } from '../../hooks/useGSAP';

export default function GSAPReveal({
  children,
  direction = 'up',
  stagger = 0,
  delay = 0,
  duration = 0.8,
  start = 'top 85%',
  className = '',
}) {
  const ref = useGSAP((gsapInstance, el) => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      gsap.set(el, { opacity: 1, x: 0, y: 0, scale: 1 });
      if (stagger > 0) {
        gsap.set(el.children, { opacity: 1, x: 0, y: 0, scale: 1 });
      }
      return;
    }

    const fromVars = { opacity: 0 };
    switch (direction) {
      case 'up': fromVars.y = 40; break;
      case 'left': fromVars.x = -40; break;
      case 'right': fromVars.x = 40; break;
      case 'scale': fromVars.scale = 0.92; fromVars.y = 20; break;
      default: fromVars.y = 40;
    }

    const target = stagger > 0 ? el.children : el;

    // Set initial state immediately so elements are hidden before animation
    gsapInstance.set(target, fromVars);

    gsapInstance.to(target, {
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      duration,
      delay,
      stagger: stagger > 0 ? stagger : undefined,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start,
        toggleActions: 'play none none none',
      },
    });
  }, [direction, stagger, delay, duration, start]);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
